import actions from './actions';

const initState = {
  isCreating: false,
  isSearching: false,
  isUpdating: false,
  isDeleting: false,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.CREATE_VOUCHER:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_VOUCHER_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.SEARCH_VOUCHERS:
    case actions.FIND_VOUCHER:
    case actions.SEARCH_VOUCHER_ORDERS:
    case actions.SEARCH_VOUCHER_STATUS:
    case actions.SEARCH_ISSUED_VOUCHERS:
    case actions.SEARCH_VOUCHER_ORDER_TRANSACTION_RECORDS:
    case actions.FIND_VOUCHER_ORDER:
    case actions.SEARCH_ISSUED_VOUCHER_TRANSACTION_RECORDS:
    case actions.FIND_ISSUED_VOUCHER_TRANSACTION_RECORD:
    case actions.SEARCH_ISSUED_VOUCHER_TRANSFER_RECORDS:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_VOUCHERS_ENDED:
    case actions.FIND_VOUCHER_ENDED:
    case actions.SEARCH_VOUCHERS_ORDERS_ENDED:
    case actions.SEARCH_ISSUED_VOUCHERS_ENDED:
    case actions.SEARCH_VOUCHER_ORDER_TRANSACTION_RECORDS_ENDED:
    case actions.FIND_VOUCHER_ORDER_ENDED:
    case actions.SEARCH_ISSUED_VOUCHER_TRANSACTION_RECORDS_ENDED:
    case actions.FIND_ISSUED_VOUCHER_TRANSACTION_RECORD_ENDED:
    case actions.SEARCH_ISSUED_VOUCHER_TRANSFER_RECORDS_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    case actions.UPDATE_VOUCHER:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_VOUCHER_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    case actions.DELETE_VOUCHERS:
      return {
        ...state,
        isDeleting: true,
      };
    case actions.DELETE_VOUCHERS_ENDED:
      return {
        ...state,
        isDeleting: false,
      };
    default:
      return state;
  }
}
